<footer dir="rtl" class="bg-gradient-to-b from-[#ffffff] to-[#f8f8f8] pt-16 text-gray-700 text-right">
	<!-- Top Section -->
	<div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-10">
		<div class="space-y-4 text-sm">
			<div class="flex items-center gap-2 md:gap-3">
				<img src="beautyLogo.png" alt="logo" loading="lazy" class="h-10 md:h-12" />
				<img src="beautyTypoghrafy.png" alt="" loading="lazy" class="h-7 md:h-12" />
			</div>

			<p class="leading-7 text-gray-500">
				اولین پلتفرم دیجیتال هوشمند تخصصی صنعت زیبایی در ایران، پل ارتباطی جامع بین فضا، آموزش، تجهیزات و خدمات زیبایی.
			</p>

			<!-- Social -->
			<div class="flex gap-3 mt-4">
				<a
					href="https://instagram.com/mrteddy.ai"
					target="_blank"
					class="w-9 h-9 rounded bg-gray-200 flex items-center justify-center hover:bg-gray-300 cursor-pointer">
					<i class="pi pi-instagram"></i>
				</a>
				<a
					href="https://t.me/beautybossaiclub"
					target="_blank"
					class="w-9 h-9 rounded bg-gray-200 flex items-center justify-center hover:bg-gray-300 cursor-pointer">
					<i class="pi pi-telegram"></i>
				</a>
				<a
					href="https://wa.me/989227303471"
					target="_blank"
					class="w-9 h-9 rounded bg-gray-200 flex items-center justify-center hover:bg-gray-300 cursor-pointer">
					<i class="pi pi-whatsapp"></i>
				</a>
				<a
					href="http://ble.ir/beautyboss"
					target="_blank"
					class="w-9 h-9 rounded bg-gray-200 flex items-center justify-center hover:bg-gray-300 cursor-pointer">
					<img src="bale.png" loading="lazy" class="w-5 h-5" />
				</a>
				<a
					href="https://rubika.ir/page/Beautyboss"
					target="_blank"
					class="w-9 h-9 rounded bg-gray-200 flex items-center justify-center hover:bg-gray-300 cursor-pointer">
					<img src="rubika.png" loading="lazy" class="w-5 h-5" />
				</a>
			</div>
		</div>
		<!-- Services -->
		<div class="space-y-3 text-sm">
			<!--			<h4 class="text-gray-800 font-semibold mb-2">خدمات</h4>-->
			<a routerLink="/ads-list" class="block hover:text-gray-400">اجاره فضا</a>
			<!--			<a href="#" class="block hover:text-gray-400">دوره‌های آموزشی</a>-->
			<!--			<a href="#" class="block hover:text-gray-400">خرید تجهیزات</a>-->
			<!--			<a href="#" class="block hover:text-gray-400">همراه شو</a>-->
			<!--			<a href="#" class="block hover:text-gray-400">تبلیغات برندها</a>-->
		</div>
		<!--		&lt;!&ndash; About links &ndash;&gt;-->
		<!--		<div class="space-y-3 text-sm">-->
		<!--			<h4 class="text-gray-800 font-semibold mb-2">درباره ما</h4>-->
		<!--			<a href="#" class="block hover:text-gray-400">درباره ما</a>-->
		<!--			<a href="#" class="block hover:text-gray-400">مجله و وبلاگ</a>-->
		<!--			<a href="#" class="block hover:text-gray-400">تماس با ما</a>-->
		<!--			<a href="#" class="block hover:text-gray-400">سوالات متداول</a>-->
		<!--			<a href="#" class="block hover:text-gray-400">قوانین و مقررات</a>-->
		<!--			<a href="#" class="block hover:text-gray-400">حریم خصوصی</a>-->
		<!--		</div>-->
		<!-- Contact -->
		<div class="space-y-4 text-sm">
			<div class="flex items-center gap-2">
				<i class="pi pi-phone"></i>
				<a href="tel:90009505" class="hover:text-gray-400">۹۰۰۰۹۵۰۵</a>
			</div>
			<div class="flex items-center gap-2">
				<i class="pi pi-envelope"></i>
				<span>iranbboss@gmail.com</span>
			</div>
			<div class="flex items-center gap-2">
				<i class="pi pi-map-marker"></i>
				<span>ایران - تهران - زنجان</span>
			</div>
		</div>

		<div class="space-y-4 text-sm">
			<a
				referrerpolicy="origin"
				target="_blank"
				href="https://trustseal.enamad.ir/?id=747745&Code=bYMN0Zlh6ynoQndWRSilTW8Dg5FFAwkK"
				><img
					referrerpolicy="origin"
					src="https://trustseal.enamad.ir/logo.aspx?id=747745&Code=bYMN0Zlh6ynoQndWRSilTW8Dg5FFAwkK"
					alt=""
					style="cursor: pointer"
					code="bYMN0Zlh6ynoQndWRSilTW8Dg5FFAwkK"
			/></a>
		</div>

		<!-- Brand -->
	</div>

	<!-- Divider -->
	<div class="border-t border-gray-200 mt-12"></div>

	<!-- Bottom -->
	<div class="max-w-7xl mx-auto px-6 py-6 text-xs text-gray-500 flex flex-col md:flex-row justify-between gap-4">
		<!-- برای چیدن آیتم‌ها از راست به چپ -->
		<div class="flex flex-wrap gap-4 justify-start md:justify-start">
			<span class="flex items-center gap-1"> <span class="w-2 h-2 bg-[#C29D59] rounded-full"></span> پرداخت امن </span>
			<span class="flex items-center gap-1"> <span class="w-2 h-2 bg-[#C29D59] rounded-full"></span> احراز هویت </span>
			<span class="flex items-center gap-1">
				<span class="w-2 h-2 bg-[#C29D59] rounded-full"></span> پشتیبانی 24/7
			</span>
			<span class="flex items-center gap-1"> <span class="w-2 h-2 bg-[#C29D59] rounded-full"></span> بازگشت وجه </span>
		</div>

		<div class=""> © 1403 BEAUTYBOSS. تمامی حقوق محفوظ است. </div>
	</div>
</footer>
